module.exports = __webpack_public_path__ + "img/fx.dcce020d.png";